export const ApiEndpoints = {
    GET_ALL_FUND: "/funds?isPaginated=false",
    GET_ALL_DUES: "/dues",
    GET_ALL_LOANS: "/loans",
    GET_ALL_SYSTEM_USERS: "/users/system",
    GET_ALL_SYSTEM_MEMBERS: "/users/members",
}